import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./MyTechProfileHomeComponent.css";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MailIcon from "@mui/icons-material/Mail";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ContactDrawer from "./ContactDrawer";
import { useDispatch, useSelector } from "react-redux";
import { techProfileLinkChangeAction } from "../../../actions/MyTechProfile/myTechProfileActions";

const Snackbar = ({ title, subtitle, show }) => {
  return (
    <div
      className={`mytechprofile-snackbar ${
        show ? "mytechprofile-snackbar-show" : ""
      }`}
    >
      <div className="mytechprofile-snackbar-content">
        <MailIcon />

        <div
          style={{
            display: "flex",
            alignItems: "start",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <div className="mytechprofile-snackbar-title">{title}</div>
          <div className="mytechprofile-snackbar-subtitle">{subtitle}</div>
        </div>
      </div>
    </div>
  );
};

const MyTechProfileHomeComponent = ({ homeRef }) => {
  const { profile } = useSelector((state) => state.editMyTechProfileStore);
  const { linkChangedFor } = useSelector(
    (state) => state.techProfileLinkChangeStore
  );
  const dispatch = useDispatch();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const nameRef = React.useRef(null);

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(profile?.email).then(() => {
      setShowSnackbar(true);
      setTimeout(() => {
        setShowSnackbar(false);
      }, 3000); // Hide after 3 seconds
    });
  };

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
    dispatch(techProfileLinkChangeAction(""));
  };

  useEffect(() => {
    if (linkChangedFor?.length > 0) {
      setIsDrawerOpen(true);
    }
  }, [linkChangedFor]);

  return (
    <>
      <div ref={homeRef} className="mytechprofile-home-container">
        <div className="mytechprofile-starfield">
          <div className="mytechprofile-stars"></div>
          <div className="mytechprofile-stars2"></div>
          <div className="mytechprofile-stars3"></div>
        </div>
        <div className="mytechprofile-glow1"></div>
        <div className="mytechprofile-glow2"></div>
        <h1 className="mytechprofile-main-heading">{profile?.introTitle}</h1>

        <div className="mytechprofile-intro-flex">
          <p ref={nameRef} className="mytechprofile-intro-text">
            Hello I'm {profile?.name}
          </p>

          <img
            src={profile?.profilePicture}
            alt={profile?.name}
            className="mytechprofile-intro-image"
          />
          <p className="mytechprofile-intro-text">a {profile?.title}</p>
        </div>

        <div className="mytechprofile-actions-flex">
          <motion.button
            className="mytechprofile-glassy-button"
            whileHover="hover"
            onClick={() => toggleDrawer()}
          >
            <motion.span
              variants={{ hover: { color: "#222" } }}
              className="mytechprofile-button-text"
            >
              View my Resume
            </motion.span>

            <motion.span
              className="mytechprofile-arrow-icon-bg"
              variants={{ hover: { x: 5 } }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <ArrowForwardIcon />
            </motion.span>

            <motion.div
              className="mytechprofile-button-hover-bg"
              variants={{ hover: { scaleX: 1, originX: 0 } }}
              initial={{ scaleX: 0 }}
              transition={{ duration: 0.4, ease: [0.43, 0.13, 0.23, 0.96] }}
            />
          </motion.button>

          <div className="mytechprofile-email-container">
            <div
              className="mytechprofile-email-copy-section"
              onClick={handleCopyEmail}
            >
              <ContentCopyIcon className="mytechprofile-email-icon" />
              <span className="mytechprofile-email-text">{profile?.email}</span>
            </div>
          </div>
        </div>

        <Snackbar
          title="Copied to Clipboard"
          subtitle="Email copied successfully"
          show={showSnackbar}
        />
        <ContactDrawer
          isOpen={isDrawerOpen}
          onClose={toggleDrawer}
          linkChangedFor={linkChangedFor}
        />
      </div>
    </>
  );
};

export default MyTechProfileHomeComponent;
